import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SessionService } from '../session/session.service';
import { SystemConfig } from '../../config/system-config';
import { Settings } from '../../domain/settings';

@Injectable()
export class SettingsService {

  constructor(private http: Http,
              public sessionService: SessionService) {
    }

  fetchSettings() {
      if (this.sessionService.punter) {
          return;
      }
      var headers: Headers = new Headers();
      this.http.get(SystemConfig.Endpoint.SETTINGS, {
          headers: headers
      }).subscribe((response: Response) => this.handleSettingsResponse(response.json()));
  }

  handleSettingsResponse(s: any) {
    this.sessionService.settings = new Settings(
        (s.DrawingPeriod > 0 ? s.DrawingPeriod : 10) * 1000,
        s.MaxStakePerTip1,
        s.MaxStakePerTip2,
        s.MaxStakePerTip3,
        s.MaxStakePerTip4,
        s.MaxStakePerTip5,
        s.MaxStakePerTip6,
        s.MaxStakePerTip7,
        s.MaxStakePerTip8,
        s.MinStakePerTip,
        s.MaxDrawingRounds
    );
  }
}




// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/settings/settings.service.ts